export const APP_ROUTE_PATHS = {
  root: '',
  dashboard: 'dashboard',
  dashboardWithdraw: 'withdraw/:id',
  strategies: 'strategies',
  strategyDeposit: 'deposit/:id',
  analytics: 'analytics',
  activity: 'activity',
  cards: 'cards',
  transfer: 'transfer',
  settings: 'settings',
  support: 'support',
  wildcard: '**',
} as const;

export const APP_ROUTE_URLS = {
  root: '/',
  dashboard: `/${APP_ROUTE_PATHS.dashboard}`,
  strategies: `/${APP_ROUTE_PATHS.strategies}`,
  strategyDeposit: `/${APP_ROUTE_PATHS.strategies}/${APP_ROUTE_PATHS.strategyDeposit.replace('/:id', '')}`,
  analytics: `/${APP_ROUTE_PATHS.analytics}`,
  activity: `/${APP_ROUTE_PATHS.activity}`,
  cards: `/${APP_ROUTE_PATHS.cards}`,
  transfer: `/${APP_ROUTE_PATHS.transfer}`,
  settings: `/${APP_ROUTE_PATHS.settings}`,
  support: `/${APP_ROUTE_PATHS.support}`,
} as const;

export const APP_ROUTE_TITLES = {
  dashboard: 'Dashboard',
  dashboardWithdraw: 'Withdraw',
  strategies: 'Strategies',
  strategyDeposit: 'Deposit',
  analytics: 'Analytics',
  activity: 'Activity',
  cards: 'Cards',
  transfer: 'Transfer',
  settings: 'Settings',
  support: 'Support',
} as const;

export const DEFAULT_APP_ROUTE_PATH = APP_ROUTE_PATHS.strategies;
